module.exports = __webpack_public_path__ + "static/LRSystem-9d75e29209c2e63236e8120342158356.png";